import { CONSTANTS } from '@pk/powerkioskutils';

import { HelperService } from '../helper.service';
import { Attachment } from './attachment';
import { LicensePlan } from './license-plan';
import { LoadFactorType } from './load-factor-type';
import { State } from './state';
import { SupplierClass } from './supplier-class';
import { SupplierCommissionRule } from './supplier-commission-rules';
import { SupplierEsignFont } from './supplier-esign-font';
import { SupplierMarketSetting } from './supplier-market-setting';
import { SupplierRateSetting } from './supplier-rate-setting';
import { SupplierReinstatementType } from './supplier-reinstatement-type';
import { SupplierSecurityQuestion } from './supplier-security-question';
import { SupplierServiceType } from './supplier-service-type';
import { SwitchType } from './switch-type';
import { User } from './user';

export class Supplier {
	public supplierId: string;
	public hasAPI: boolean;
	public name: string;
	public serviceTypeId: string;
	public isActive: boolean;
	public stateId: string;
	public id: string;
	public logo: string;
	public address1: string;
	public address2: string;
	public city: string;
	public zipCode: string;
	public website: string;
	public puct: string;
	public underwriterId: string;
	public bbbRating: number;
	public parentId: string;
	public maxNumLocations: number;
	public supplierReinstatementTypeId: number;
	public reinstatementFormAttachmentId: string;
	public gasBufferMargin: number;
	public electricBufferMargin: number;
	public personalGuaranteeAttachmentId: string;
	public businessGuaranteeAttachmentId: string;
	public logoAttachmentId: string;
	public supplierClassId: number;
	public loadFactorTypeId: number;
	public hasConfirmationMapping: boolean;
	public hasFlowCheckMapping: boolean;
	public allowCommercialMatrixRenewal: boolean;
	public hasResidentialMatrixRenewal: boolean;
	public allowResidentialPoa: boolean;
	public showResidentialPreferredContactMethod: boolean;

	public user: User;
	public underwriter: User;
	public switchTypes: SwitchType[];
	public commissionRules: SupplierCommissionRule[];
	public serviceTypes: SupplierServiceType[];
	public attachments: Attachment[];
	public logins: User[];
	public state: State;
	public supplierRateSettings: SupplierRateSetting[];
	public parent: Supplier;
	public supplierReinstatementType: SupplierReinstatementType;
	public licensePlans: LicensePlan[];
	public supplierClass: SupplierClass;
	public securityQuestions: SupplierSecurityQuestion[];
	public esignFonts: SupplierEsignFont[];
	public loadFactorType: LoadFactorType;
	public supplierMarketSettings: SupplierMarketSetting[];

	public hasCommissionMapping: boolean;
	public hasParentCommissionMapping: boolean;
	public hasChildren: boolean;

	constructor(supplier?: Supplier) {
		Object.assign(this, supplier);

		this.logins = this.logins ? this.logins.map(l => new User(l)) : this.logins;
		this.commissionRules = this.commissionRules ? this.commissionRules.map(c => new SupplierCommissionRule(c)) : this.commissionRules;
		this.supplierMarketSettings = this.supplierMarketSettings
			? this.supplierMarketSettings.map(s => new SupplierMarketSetting(s))
			: this.supplierMarketSettings;
		this.logo = this.logo ? HelperService.getPath(this.logo, true) : '';
	}

	get hasPricingCopilot(): boolean {
		return this.licensePlans?.map(l => l.id).some(id => CONSTANTS.licensePlans.pricingAnalytics.includes(id));
	}

	get hasPricingCopilotMatrix(): boolean {
		return this.licensePlans?.map(l => l.id).some(id => CONSTANTS.licensePlans.pricingAnalyticsMatrix.includes(id));
	}

	get hasPricingCopilotCustom(): boolean {
		return this.licensePlans?.map(l => l.id).some(id => CONSTANTS.licensePlans.pricingAnalyticsCustom.includes(id));
	}

	get hasPricingCopilotResidential(): boolean {
		return this.licensePlans?.map(l => l.id).some(id => CONSTANTS.licensePlans.pricingAnalyticsResidential.includes(id));
	}

	get isBillRequiredForEnrollment(): boolean {
		return this.supplierMarketSettings?.some(s => s.isBillRequiredForEnrollment);
	}

	public getFullAddressLine(): string {
		let addressLine = '';

		addressLine += this.address1 + ' ';
		addressLine += this.address2 ? this.address2 + ' ' : '';
		addressLine += this.city + ', ';
		addressLine += this.state ? this.state.stateShort + ' ' : ' ';
		addressLine += this.zipCode;

		return addressLine;
	}
}
